import { useState } from 'react';
import { useLingui } from '@lingui/react/macro';

import { FiltersButton } from '@/design_system/Filters/FiltersButton/FiltersButton';
import { FiltersDrawer } from '@/design_system/Filters/FiltersDrawer/FiltersDrawer';
import InputSearch from '@/design_system/InputSearch';
import Stack from '@/design_system/Stack';

import { useFilters } from '../FiltersState';

import { FiltersGroup } from './FiltersGroup';
import { FiltersTrait } from './FiltersTrait';
import { FiltersType } from './FiltersType';

export const MobileFilters = () => {
  const { t } = useLingui();
  const [isOpen, setIsOpen] = useState(false);
  const { search, activeFiltersCount, clearFilters } = useFilters();

  return (
    <Stack row gap="1rem" alignItems="center">
      <InputSearch
        ariaLabel={t({
          id: 'settings.organization.entities.entities.search.label',
          message: 'Search entities',
        })}
        placeholder={t({
          id: 'settings.organization.entities.entities.search.placeholder',
          message: 'Search entities...',
        })}
        value={search.search}
        onChange={search.debouncedSetSearch}
        style={{ flex: 1 }}
      />
      <FiltersDrawer
        button={<FiltersButton count={activeFiltersCount} onClick={() => setIsOpen(true)} />}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        onClearFilters={activeFiltersCount ? clearFilters : undefined}
      >
        <FiltersTrait />
        <FiltersType />
        <FiltersGroup />
      </FiltersDrawer>
    </Stack>
  );
};
